/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkoutRating } from './WorkoutRating';
import {
    WorkoutRatingFromJSON,
    WorkoutRatingFromJSONTyped,
    WorkoutRatingToJSON,
    WorkoutRatingToJSONTyped,
} from './WorkoutRating';
import type { CompletedTraining } from './CompletedTraining';
import {
    CompletedTrainingFromJSON,
    CompletedTrainingFromJSONTyped,
    CompletedTrainingToJSON,
    CompletedTrainingToJSONTyped,
} from './CompletedTraining';

/**
 * 
 * @export
 * @interface CreateHistoryEntry
 */
export interface CreateHistoryEntry {
    /**
     * 
     * @type {string}
     * @memberof CreateHistoryEntry
     */
    deckId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateHistoryEntry
     */
    planWorkoutId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateHistoryEntry
     */
    completionTime: number;
    /**
     * 
     * @type {string}
     * @memberof CreateHistoryEntry
     */
    trainingDateIsoString: string;
    /**
     * 
     * @type {WorkoutRating}
     * @memberof CreateHistoryEntry
     */
    rating?: WorkoutRating;
    /**
     * 
     * @type {CompletedTraining}
     * @memberof CreateHistoryEntry
     */
    historyEntry: CompletedTraining;
    /**
     * 
     * @type {number}
     * @memberof CreateHistoryEntry
     */
    bodyweight: number;
}

/**
 * Check if a given object implements the CreateHistoryEntry interface.
 */
export function instanceOfCreateHistoryEntry(value: object): value is CreateHistoryEntry {
    if (!('deckId' in value) || value['deckId'] === undefined) return false;
    if (!('completionTime' in value) || value['completionTime'] === undefined) return false;
    if (!('trainingDateIsoString' in value) || value['trainingDateIsoString'] === undefined) return false;
    if (!('historyEntry' in value) || value['historyEntry'] === undefined) return false;
    if (!('bodyweight' in value) || value['bodyweight'] === undefined) return false;
    return true;
}

export function CreateHistoryEntryFromJSON(json: any): CreateHistoryEntry {
    return CreateHistoryEntryFromJSONTyped(json, false);
}

export function CreateHistoryEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateHistoryEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'deckId': json['deckId'],
        'planWorkoutId': json['planWorkoutId'] == null ? undefined : json['planWorkoutId'],
        'completionTime': json['completionTime'],
        'trainingDateIsoString': json['trainingDateIsoString'],
        'rating': json['rating'] == null ? undefined : WorkoutRatingFromJSON(json['rating']),
        'historyEntry': CompletedTrainingFromJSON(json['historyEntry']),
        'bodyweight': json['bodyweight'],
    };
}

export function CreateHistoryEntryToJSON(json: any): CreateHistoryEntry {
    return CreateHistoryEntryToJSONTyped(json, false);
}

export function CreateHistoryEntryToJSONTyped(value?: CreateHistoryEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deckId': value['deckId'],
        'planWorkoutId': value['planWorkoutId'],
        'completionTime': value['completionTime'],
        'trainingDateIsoString': value['trainingDateIsoString'],
        'rating': WorkoutRatingToJSON(value['rating']),
        'historyEntry': CompletedTrainingToJSON(value['historyEntry']),
        'bodyweight': value['bodyweight'],
    };
}

